module.exports = __webpack_public_path__ + "img/H-63-ST-1200-BE.0b5c47d3.png";